import { render, staticRenderFns } from "./CadastrarUnidade.vue?vue&type=template&id=1e5047b4&"
import script from "./CadastrarUnidade.vue?vue&type=script&lang=js&"
export * from "./CadastrarUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports